
(function () {
  function formatDate(el) {
    if (el.dataset.formatted) return;

    const raw = el.textContent.trim();
    const date = new Date(raw);

    if (!isNaN(date)) {
      el.textContent = date.toLocaleDateString("ro-RO", {
        day: "numeric",
        month: "long",
        year: "numeric"
      });
      el.dataset.formatted = "true";
    }
  }

  function formatTime(el) {
    if (el.dataset.formatted) return;

    const text = el.textContent.trim();
    const parts = text.split('-');

    if (parts.length !== 2) return;

    function to24Hour(timeStr) {
      const [time, modifier] = timeStr.trim().split(' ');
      let [hours, minutes] = time.split(':');

      hours = parseInt(hours, 10);

      if (modifier && modifier.toLowerCase() === 'pm' && hours !== 12) hours += 12;
      if (modifier && modifier.toLowerCase() === 'am' && hours === 12) hours = 0;

      return `${hours.toString().padStart(2, '0')}:${minutes}`;
    }

    const start = to24Hour(parts[0]);
    const end = to24Hour(parts[1]);

    el.textContent = `${start} – ${end}`;
    el.dataset.formatted = "true";
  }

  function runFormatting() {
    document.querySelectorAll('.evey__event-info-date-date').forEach(formatDate);
    document.querySelectorAll('.evey__event-info-date-time').forEach(formatTime);
  }

  function init() {
    // Run immediately in case content is already there
    runFormatting();

    // Watch for Evey injecting content
    const observer = new MutationObserver(() => {
      runFormatting();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  init();
})();